import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  // Section header
  advancedOptionsTitle: {
    description: 'Title for the advanced options section',
    defaultMessage: 'Advanced Options',
    id: 'Yjn2Hv',
  },
  advancedOptionsDescription: {
    description: 'Description text for the advanced options section',
    defaultMessage: 'Optimize your workflows with these additional options and features.',
    id: 'SVY+KT',
  },

  // Common elements
  addToDoLater: {
    description: 'Text for the checkbox to add a task to do later',
    defaultMessage: 'Add to "Do Later"',
    id: 'y8Vdc3',
  },
  learnMore: {
    description: 'Text for the learn more link',
    defaultMessage: 'Learn more',
    id: 'agN54X',
  },

  // Card 1: Rate Shopping
  rateShoppingTitle: {
    description: 'Title for the rate shopping card',
    defaultMessage: 'Automate rate shopping',
    id: 'swKmuh',
  },
  rateShoppingDescription: {
    description: 'Description for the rate shopping card',
    defaultMessage: 'Automatically apply the best rate to all your orders with Rate Shopper. Add custom rules to meet to your needs.',
    id: 'G57I7w',
  },

  // Card 2: ShipStation Connect
  connectTitle: {
    description: 'Title for the ShipStation Connect card',
    defaultMessage: 'Print with ease using ShipStation Connect',
    id: 'O+MYj3',
  },
  connectDescription: {
    description: 'Description for the ShipStation Connect card',
    defaultMessage:
      'Download the Connect app to print to multiple workstations anywhere in your network and connect a scale to import exact shipment weight.',
    id: 'NwHjbl',
  },

  // Card 2: Label Layout
  labelLayoutTitle: {
    description: 'Title for the label layout card',
    defaultMessage: 'Set your label layout',
    id: 'V3nSdU',
  },
  labelLayoutDescription: {
    description: 'Description for the label layout card',
    defaultMessage:
      'Tell ShipStation which type of label layout to print based on your printer type. Choose to print labels only or labels and packing slips together.',
    id: '7yxZ1z',
  },

  // Card 3: Branded Tracking
  brandedTrackingTitle: {
    description: 'Title for the branded tracking page card',
    defaultMessage: 'Create a branded tracking page',
    id: 'ehhIMW',
  },
  brandedTrackingDescription: {
    description: 'Description for the branded tracking page card',
    defaultMessage:
      "Have your customers track their shipments on a customized tracking page with your store's branding. Include your logo, colors, social media links, and more.",
    id: 'no5HP7',
  },

  // Card 4: Custom Package Sizes
  packageSizesTitle: {
    description: 'Title for the custom package sizes card',
    defaultMessage: 'Add custom package sizes',
    id: 'fjP7e+',
  },
  packageSizesDescription: {
    description: 'Description for the custom package sizes card',
    defaultMessage:
      'Add the package sizes you use so you can select in a single click or assign to a preset. Including the right dimensions helps ensure accurate rates.',
    id: '9VCnDg',
  },

  // Card 5: Packing Slips
  packingSlipsTitle: {
    description: 'Title for the packing slips card',
    defaultMessage: 'Customize your packing slips',
    id: 'NNo1Se',
  },
  packingSlipsDescription: {
    description: 'Description for the packing slips card',
    defaultMessage:
      'Create customized packing slip templates with your store branding and any other details you need to support your business and workflows.',
    id: 'yK7HZA',
  },

  // Card 6: Fulfillment
  fulfillmentTitle: {
    description: 'Title for the fulfillment card',
    defaultMessage: 'Get started with ShipStation fulfillment',
    id: 'h+VlCu',
  },
  fulfillmentDescription: {
    description: 'Description for the fulfillment card',
    defaultMessage: 'Fulfilled by ShipStation has warehouses nationwide to speed up your fulfillment and save on shipping.',
    id: 'RxlGc6',
  },
  // Inventory Warehouse Card
  warehouseTitle: {
    description: 'Title for the inventory warehouse card',
    defaultMessage: 'Add inventory warehouses',
    id: '2iP5S5',
  },
  warehouseDescription: {
    description: 'Description for the inventory warehouse card',
    defaultMessage: 'Add another inventory warehouse location or configure the locations within your warehouse to better track stock.',
    id: 'ujOmDC',
  },

  // Pickup Settings Card
  pickupTitle: {
    description: 'Title for the pickup settings card',
    defaultMessage: 'Manage pickup settings',
    id: 'n90WHe',
  },
  pickupDescription: {
    description: 'Description for the pickup settings card',
    defaultMessage: 'Configure where and when you would like to have your shipments picked up.',
    id: 'agB3DD',
  },
  negotiatedCarrierTitle: {
    description: 'Title for the negotiated carrier card',
    defaultMessage: 'Connect negotiated carrier accounts',
    id: 'zqr7Lx',
  },
  negotiatedCarrierDescription: {
    description: 'Description for the negotiated carrier card',
    defaultMessage: "Ship with your own contracted rates in addition to ShipStation's included carrier rates.",
    id: 'dHQxt0',
  },
  // International Shipping Card
  internationalTitle: {
    description: 'Title for the international shipping card',
    defaultMessage: 'Configure international shipping settings',
    id: 'Y+lHZa',
  },
  internationalDescription: {
    description: 'Description for the international shipping card',
    defaultMessage:
      'Ensure smooth cross-border deliveries by adding your international shipping preferences and details like customs defaults and tax ID numbers.',
    id: 'WQD2L5',
  },
  // Inventory Sync Card
  inventorySyncTitle: {
    description: 'Title for the inventory sync card',
    defaultMessage: 'Set up Inventory Sync',
    id: '5ELFrM',
  },
  inventorySyncDescription: {
    description: 'Description for the inventory sync card',
    defaultMessage: 'Automatically sync stock counts between ShipStation and your selling channels.',
    id: 'Emh47N',
  },
  // Reordering Card
  reorderingTitle: {
    description: 'Title for the reordering card',
    defaultMessage: 'Reordering',
    id: '5kK/E5',
  },
  reorderingDescription: {
    description: 'Description for the reordering card',
    defaultMessage: 'Intelligenlty forecast stock replenishments and create purchase orders directly in ShipStation.',
    id: 'Tm+F9e',
  },
  // Lot Tracking Card
  lotTrackingTitle: {
    description: 'Title for the lot tracking card',
    defaultMessage: 'Lot Tracking',
    id: '+Bhyjj',
  },
  lotTrackingDescription: {
    description: 'Description for the lot tracking card',
    defaultMessage: 'Precise tracking of inventory by lot, allowing for easy management of batches and expiration dates.',
    id: 's/p85I',
  },
  // Auto Routing Card
  autoRoutingTitle: {
    description: 'Title for the auto routing card',
    defaultMessage: 'Enable Order Routing',
    id: '6IhfHl',
  },
  autoRoutingDescription: {
    description: 'Description for the auto routing card',
    defaultMessage: 'Automatically send shipments from the warehouse with inventory closest to the recipient.',
    id: 'CrL58g',
  },
  // Bundles Card
  bundlesTitle: {
    description: 'Title for the bundles card',
    defaultMessage: 'Configure product bundles',
    id: 'Muqbxs',
  },
  bundlesDescription: {
    description: 'Description for the bundles card',
    defaultMessage: 'Group multiple products together in a single bundle when selling under a single SKU.',
    id: 'NA+Kd6',
  },
  // API Card
  apiTitle: {
    description: 'Title for the API card',
    defaultMessage: 'API',
    id: 'tmM1Hg',
  },
  apiDescription: {
    description: 'Description for the API card',
    defaultMessage: 'Group multiple products together in a single bundle when selling under a single SKU.',
    id: '8PBQUr',
  },
  // Branded Returns Card
  brandedReturnsTitle: {
    description: 'Title for the branded returns card',
    defaultMessage: 'Brand your customer return portal',
    id: 'XzLfaU',
  },
  brandedReturnsDescription: {
    description: 'Description for the branded returns card',
    defaultMessage: 'Add your brand logo and a custom theme to the returns portal for a personalized return experience.',
    id: 'vcXeBK',
  },
  // Returns URL Card
  returnsUrlTitle: {
    description: 'Title for the returns URL card',
    defaultMessage: 'Add the URL to your website',
    id: 'Eaz5YA',
  },
  returnsUrlDescription: {
    description: 'Description for the returns URL card',
    defaultMessage: 'Place this link on your website to allow customers to create return labels themselves.',
    id: '2DuRKG',
  },
  // Returns Help Card
  returnsHelpTitle: {
    description: 'Title for the returns help card',
    defaultMessage: 'When you need to offer returns, we can help',
    id: '9zi4Hy',
  },
  returnsHelpDescription: {
    description: 'Description for the returns help card',
    defaultMessage:
      'When you are ready to offer returns, ShipStation offers the best-in-class tools to help you! Just visit the Returns page to get started!',
    id: 'VSvDzD',
  },
  // LinkText messages
  warehouseLinkText: {
    description: 'Link text for the inventory warehouse card',
    defaultMessage: 'Add Warehouses',
    id: 'UaXZE7',
  },
  pickupLinkText: {
    description: 'Link text for the pickup settings card',
    defaultMessage: 'Pickup Settings',
    id: 'k6i/HR',
  },
  rateShoppingLinkText: {
    description: 'Link text for the rate shopping card',
    defaultMessage: 'Rate Shopper',
    id: 'jg7/Eh',
  },
  connectLinkText: {
    description: 'Link text for the ShipStation Connect card',
    defaultMessage: 'Connect App',
    id: 'WgTgKk',
  },
  negotiatedCarrierLinkText: {
    description: 'Link text for the negotiated carrier card',
    defaultMessage: 'Carrier Accounts',
    id: 'm3vYJC',
  },
  internationalLinkText: {
    description: 'Link text for the international shipping card',
    defaultMessage: 'International Settings',
    id: 'Mti54N',
  },
  labelLayoutLinkText: {
    description: 'Link text for the label layout card',
    defaultMessage: 'Label Settings',
    id: 'MNw5Q+',
  },
  brandedTrackingLinkText: {
    description: 'Link text for the branded tracking page card',
    defaultMessage: 'Tracking Page',
    id: 'G0THu0',
  },
  packageSizesLinkText: {
    description: 'Link text for the custom package sizes card',
    defaultMessage: 'Package Sizes',
    id: 'hVemXH',
  },
  packingSlipsLinkText: {
    description: 'Link text for the packing slips card',
    defaultMessage: 'Packing Slips',
    id: 'tv0fRp',
  },
  fulfillmentLinkText: {
    description: 'Link text for the fulfillment card',
    defaultMessage: 'Fulfillment',
    id: 'tt4apD',
  },
  inventorySyncLinkText: {
    description: 'Link text for the inventory sync card',
    defaultMessage: 'Inventory Sync',
    id: 'iS7zm2',
  },
  reorderingLinkText: {
    description: 'Link text for the reordering card',
    defaultMessage: 'Reordering',
    id: '4+HEwl',
  },
  autoRoutingLinkText: {
    description: 'Link text for the auto routing card',
    defaultMessage: 'Order Routing',
    id: 'dzSLQ1',
  },
  bundlesLinkText: {
    description: 'Link text for the bundles card',
    defaultMessage: 'Product Bundles',
    id: 'W/Fq7/',
  },
  lotTrackingLinkText: {
    description: 'Link text for the lot tracking card',
    defaultMessage: 'Lot Tracking',
    id: '9CL5mg',
  },
  apiLinkText: {
    description: 'Link text for the API card',
    defaultMessage: 'API Access',
    id: 'lsCSYf',
  },
  brandedReturnsLinkText: {
    description: 'Link text for the branded returns card',
    defaultMessage: 'Returns Portal',
    id: '5Fwo0G',
  },
  returnsUrlLinkText: {
    description: 'Link text for the returns URL card',
    defaultMessage: 'Get URL',
    id: 'e1u1mU',
  },
  returnsHelpLinkText: {
    description: 'Link text for the returns help card',
    defaultMessage: 'Returns Page',
    id: 'ZUQ+Lj',
  },
  shopifyTodoTitle: {
    description: 'Title for the Shopify todo card',
    defaultMessage: 'Configure Shopify returns portal',
    id: 'QmfQTR',
  },
  shopifyTodoDescription: {
    description: 'Description for the Shopify todo card',
    defaultMessage: 'Brand and configure your returns portal to start enabling customer self-service returns.',
    id: 'fAHfCj',
  },
  // Freemium Todo Cards
  freemiumConnectStoreTitle: {
    description: 'Title for the freemium connect store card',
    defaultMessage: 'Connect your store',
    id: 'aC00HI',
  },
  freemiumConnectStoreDescription: {
    description: 'Description for the freemium connect store card',
    defaultMessage: 'Connect your store to automatically import orders. You can also add orders manually or import via CSV at any time.',
    id: 'qLw3eB',
  },
  freemiumConnectStoreLinkText: {
    description: 'Link text for the freemium connect store card',
    defaultMessage: 'Connect my store',
    id: 'vKBcAH',
  },
  freemiumAddShipFromAddressTitle: {
    description: 'Title for the freemium add ship from address card',
    defaultMessage: 'Add your ship from address',
    id: 'rs0SUZ',
  },
  freemiumAddShipFromAddressDescription: {
    description: 'Description for the freemium add ship from address card',
    defaultMessage: "Enter the address where you'll primarily be shipping from. You can add additional addresses later.",
    id: 'QmUIHg',
  },
  freemiumAddShipFromAddressLinkText: {
    description: 'Link text for the freemium add ship from address card',
    defaultMessage: 'Add ship from address',
    id: 'XKokmH',
  },
  freemiumAddPaymentMethodTitle: {
    description: 'Title for the freemium add payment method card',
    defaultMessage: 'Add your payment method',
    id: 'CKXMLl',
  },
  freemiumAddPaymentMethodDescription: {
    description: 'Description for the freemium add payment method card',
    defaultMessage: "Activate payment to access ShipStation's discounted rates, with up to 89% off retail.",
    id: 'ouE+Qc',
  },
  freemiumAddPaymentMethodLinkText: {
    description: 'Link text for the freemium add payment method card',
    defaultMessage: 'Add payment method',
    id: 'FbQwu4',
  },
  freemiumConnectTitle: {
    description: 'Title for the freemium connect card',
    defaultMessage: 'Print with ease using ShipStation Connect',
    id: '3nDHvO',
  },
  freemiumConnectDescription: {
    description: 'Description for the freemium connect card',
    defaultMessage: 'Download the Connect app to print to workstations anywhere in your network.',
    id: 'U/7vwx',
  },
  freemiumConnectLinkText: {
    description: 'Link text for the freemium connect card',
    defaultMessage: 'Download connect',
    id: 'soLl5k',
  },
  freemiumShipstation101Title: {
    description: 'Title for the freemium shipstation 101 card',
    defaultMessage: 'Get started with ShipStation 101',
    id: 'gX0Qbo',
  },
  freemiumShipstation101Description: {
    description: 'Description for the freemium shipstation 101 card',
    defaultMessage: 'Learn the basics of ShipStation from our Help Center, ShipStation University and Community forum.',
    id: '1FiOt+',
  },
  freemiumShipstation101LinkText: {
    description: 'Link text for the freemium shipstation 101 card',
    defaultMessage: 'View our Help Center',
    id: 'ExQQbx',
  },
  freemiumRateShoppingTitle: {
    description: 'Title for the freemium rate shopping card',
    defaultMessage: 'Automate rate shopping',
    id: '+wbyZR',
  },
  freemiumRateShoppingDescription: {
    description: 'Description for the freemium rate shopping card',
    defaultMessage: 'Automatically apply the best rate to all your shipments with Rate Shopper.',
    id: 'Cg1vV/',
  },
  freemiumRateShoppingLinkText: {
    description: 'Link text for the freemium rate shopping card',
    defaultMessage: 'Automate rate shopping',
    id: '2Iptvj',
  },
  freemiumLabelLayoutTitle: {
    description: 'Title for the freemium label layout card',
    defaultMessage: 'Set your label layout',
    id: 'wiYc6x',
  },
  freemiumLabelLayoutDescription: {
    description: 'Description for the freemium label layout card',
    defaultMessage: 'Select your label layout based on your printer and choose to print labels only or with packing slips.',
    id: 'fKjPad',
  },
  freemiumLabelLayoutLinkText: {
    description: 'Link text for the freemium label layout card',
    defaultMessage: 'Select label layout',
    id: 'F5z863',
  },
  freemiumCreateReturnLabelTitle: {
    description: 'Title for the freemium create return label card',
    defaultMessage: 'Create a return label',
    id: 'spDwBF',
  },
  freemiumCreateReturnLabelDescription: {
    description: 'Description for the freemium create return label card',
    defaultMessage: 'You can manually add returns and generate return labels right from the Returns Grid here in ShipStation.',
    id: 's0QpkV',
  },
  freemiumCreateReturnLabelLinkText: {
    description: 'Link text for the freemium create return label card',
    defaultMessage: 'Create a return label',
    id: 'HCbB1j',
  },
  freemiumImportProductsTitle: {
    description: 'Title for the freemium import products card',
    defaultMessage: 'Import your products',
    id: 'NkPQR8',
  },
  freemiumImportProductsDescription: {
    description: 'Description for the freemium import products card',
    defaultMessage:
      'Import your product info via CSV to maintain accurate stock across channels, forecast reorder quantities, create purchase orders, and more.',
    id: 'ceADEg',
  },
  freemiumImportProductsLinkText: {
    description: 'Link text for the freemium import products card',
    defaultMessage: 'Import products',
    id: 'EGbgIH',
  },
  freemiumSetupReturnsTitle: {
    description: 'Title for the freemium setup returns card',
    defaultMessage: 'Set up returns',
    id: 'nsvyLI',
  },
  freemiumSetupReturnsDescription: {
    description: 'Description for the freemium setup returns card',
    defaultMessage:
      'Give your customers an easy way to return products through a branded portal with Returns & Exchanges. Set up returns and rules on a per-store basis.',
    id: 'UDp5I1',
  },
  freemiumSetupReturnsLinkText: {
    description: 'Link text for the freemium setup returns card',
    defaultMessage: 'Set up returns',
    id: 'u//1pE',
  },

  // FTU Skip Cards
  ftuConnectStoreTitle: {
    description: 'Title for the FTU connect store card',
    defaultMessage: 'Connect a store',
    id: 'YFsPvJ',
  },
  ftuConnectStoreDescription: {
    description: 'Description for the FTU connect store card',
    defaultMessage: 'Connect a store (including shopping carts, marketplaces, ERPs, and more) to begin importing your orders.',
    id: '4cX2JH',
  },
  ftuConnectStoreLinkText: {
    description: 'Link text for the FTU connect store card',
    defaultMessage: 'Connect store',
    id: 'SN6BQZ',
  },
  ftuAddShipFromTitle: {
    description: 'Title for the FTU add ship from card',
    defaultMessage: 'Add ship from address',
    id: 'LxdIZj',
  },
  ftuAddShipFromDescription: {
    description: 'Description for the FTU add ship from card',
    defaultMessage: "Add the address where you'll primarily be shipping from. You can add multiple warehouse addresses, if needed.",
    id: 'JJsFcd',
  },
  ftuAddShipFromLinkText: {
    description: 'Link text for the FTU add ship from card',
    defaultMessage: 'Add warehouses',
    id: 'ZBY90Q',
  },
  ftuAddPaymentMethodTitle: {
    description: 'Title for the FTU add payment method card',
    defaultMessage: 'Set up payment method',
    id: 'sl09fd',
  },
  ftuAddPaymentMethodDescription: {
    description: 'Description for the FTU add payment method card',
    defaultMessage: 'Set up your payment method to save up to 90% on shipping labels.',
    id: 'naglvv',
  },
  ftuAddPaymentMethodLinkText: {
    description: 'Link text for the FTU add payment method card',
    defaultMessage: 'Add payment',
    id: 'hvL95o',
  },
  ftuImportProductsTitle: {
    description: 'Title for the FTU import products card',
    defaultMessage: 'Import products',
    id: 'b0KgqG',
  },
  ftuImportProductsDescription: {
    description: 'Description for the FTU import products card',
    defaultMessage:
      'Import your product info via CSV to maintain accurate stock across channels, forecast reorder quantities, create purchase orders, and more.',
    id: 'oJkLy9',
  },
  ftuImportProductsLinkText: {
    description: 'Link text for the FTU import products card',
    defaultMessage: 'Import products',
    id: 'jrG7xE',
  },
  ftuSetupReturnsTitle: {
    description: 'Title for the FTU setup returns card',
    defaultMessage: 'Set up returns',
    id: 'b4fVEq',
  },
  ftuSetupReturnsDescription: {
    description: 'Description for the FTU setup returns card',
    defaultMessage:
      'Give your customers an easy way to return products through a branded portal with Returns & Exchanges. Set up returns and rules on a per-store basis.',
    id: 'paPniS',
  },
  ftuSetupReturnsLinkText: {
    description: 'Link text for the FTU setup returns card',
    defaultMessage: 'Set up returns',
    id: 'Qag6wH',
  },

  // Upload Products Card
  uploadProductsTitle: {
    description: 'Title for the upload products card',
    defaultMessage: 'Upload or view products',
    id: 'CLMmon',
  },
  uploadProductsDescription: {
    description: 'Description for the upload products card',
    defaultMessage: 'Get all your products in ShipStation. You can tag them, assign custom packaging, and more.',
    id: 'L9tYFI',
  },
  uploadProductsLinkText: {
    description: 'Link text for the upload products card',
    defaultMessage: 'View products',
    id: '5biFlE',
  },
  // Account Users Card
  accountUsersTitle: {
    description: 'Title for the account users card',
    defaultMessage: 'Create account users',
    id: 'T6GoCo',
  },
  accountUsersDescription: {
    description: 'Description for the account users card',
    defaultMessage: 'Add the team to your ShipStation account and set permissions.',
    id: 'tks/0w',
  },
  accountUsersLinkText: {
    description: 'Link text for the account users card',
    defaultMessage: 'Add users',
    id: 'he+K84',
  },
  // Demo Order Card
  demoOrderTitle: {
    description: 'Title for the demo order card',
    defaultMessage: 'Explore a demo order',
    id: 'jdagi8',
  },
  demoOrderDescription: {
    description: 'Description for the demo order card',
    defaultMessage: "Take a tour or test out ShipStation's functionality with a demo order.",
    id: 'co3RZA',
  },
  demoOrderLinkText: {
    description: 'Link text for the demo order card',
    defaultMessage: 'Explore a demo',
    id: 'DHD4JN',
  },
  // Webinar todos
  getStartedWebinarTitle: {
    description: 'Title for the Get Started with ShipStation webinar card',
    defaultMessage: 'Get Started With ShipStation',
    id: 'k2d5Hy',
  },
  getStartedWebinarDescription: {
    description: 'Description for the Get Started with ShipStation webinar card',
    defaultMessage: 'Join our Webinar; get a full walk through of the essentials for setting up your ShipStation account',
    id: 's6wPX7',
  },

  accountOptimizationWebinarTitle: {
    description: 'Title for the Account Optimization webinar card',
    defaultMessage: 'Account Optimization',
    id: 'J5BE58',
  },
  accountOptimizationWebinarDescription: {
    description: 'Description for the Account Optimization webinar card',
    defaultMessage: 'Become a ShipStation Pro; join us for a webinar that dives deeper into automation and advanced workflow optimizations',
    id: 'EY06oK',
  },
  shipstationInventoryTitle: {
    description: 'Title for the shipstation inventory card',
    defaultMessage: 'Enable ShipStation Inventory',
    id: '647T5k',
  },
  shipstationInventoryDescription: {
    description: 'Description for the shipstation inventory card',
    defaultMessage: 'Track inventory levels and sync quantities with your connected stores.',
    id: 'wMASPA',
  },
  shipstationInventoryLinkText: {
    description: 'Link text for the shipstation inventory card',
    defaultMessage: 'Inventory Settings',
    id: 'VXV7j6',
  },
  // Automation More Setup Card
  automationMoreSetupTitle: {
    description: 'Title for the automation setup card',
    defaultMessage: 'Set up more Automations',
    id: 'NcryYN',
  },
  automationMoreSetupDescription: {
    description: 'Description for the automation more setup card',
    defaultMessage:
      'ShipStation has a powerful suite of automation rules to help you save time, reduce errors, and get work done faster. This includes setting up customized Rate Shoppers, tagging orders for filtering, setting up alerts, and sending customer tracking information emails.',
    id: 'D09wmP',
  },
  automationMoreSetupLinkText: {
    description: 'Link text for the automation more setup card',
    defaultMessage: 'Automation',
    id: '1Fk7p9',
  },

  // Insurance Settings Card
  setupInsuranceTitle: {
    description: 'Title for the set up insurance todo card',
    defaultMessage: 'Set up insurance',
    id: 'VqlyZW',
  },
  setupInsuranceDescription: {
    description: 'Description for the set up insurance todo card',
    defaultMessage:
      'Protect your shipments by setting up automated insurance options. Choose to insure all shipments or create custom rules based on order value.',
    id: 'UTcXM2',
  },
  setupInsuranceLinkText: {
    description: 'Link text for the set up insurance todo card',
    defaultMessage: 'Set up Insurance',
    id: 'owCiAA',
  },

  // Phone Number Capture Card
  phoneNumberCaptureTitle: {
    description: 'Title for the phone number capture todo card',
    defaultMessage: 'Set up account phone number',
    id: 'O+v+of',
  },
  phoneNumberCaptureDescription: {
    description: 'Description for the phone number capture todo card',
    defaultMessage: 'Stay informed with alerts and access to onboarding help.',
    id: 'WacWtd',
  },
  phoneNumberCaptureLinkText: {
    description: 'Link text for the phone number capture todo card',
    defaultMessage: 'Add phone number',
    id: 'UcTlu+',
  },
});
